"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const regist_1 = require("../../redux/regist");
const actionTypes_1 = require("../base/app/actionTypes");
const DeletePopUpLayout_1 = require("../base/layout/DeletePopUpLayout");
const popup_1 = require("../base/popup");
const action_1 = require("./action");
const actionType_1 = require("./actionType");
const function_1 = require("./function");
const lodash_1 = __importDefault(require("lodash"));
const constants_1 = require("./constants");
let activeRef = false;
const menuConditions = {
    qna: ['answer_modify', 'answer', 'regist', 're_regist'],
    resource: ['regist', 'modify'],
    notice: ['regist', 'modify'],
};
const isMenuConditionMatched = (menu, detail) => {
    return menuConditions[menu]?.some(condition => detail === condition || detail.includes(condition));
};
let stateList = []; // 상태 리스트 관리
// 미들웨어 등록
regist_1.MiddlewareRegistry.register(store => next => (action) => {
    const { dispatch } = store;
    switch (action.type) {
        case actionTypes_1.APP_WILL_LOAD: {
            APP.eventManager.subscribe('MENU_MOVE_ACTIVE', isActive => {
                activeRef = isActive;
            });
            // 새로고침 시 상태 복원
            const itemName = location.pathname.includes('admin-page') ? 'admin_menu' : 'test_menu';
            const savedMenus = localStorage.getItem(itemName);
            if (savedMenus) {
                const prevMenus = JSON.parse(savedMenus);
                if (Array.isArray(prevMenus)) {
                    stateList = prevMenus;
                    const currentMenu = stateList[stateList.length - 1] || null;
                    // 현재 메뉴 복원
                    if (currentMenu) {
                        dispatch((0, action_1.updateMenu)(currentMenu.depths, currentMenu.menu, currentMenu.id, currentMenu.props, true));
                    }
                }
            }
            // popstate 이벤트 리스너 등록
            window.addEventListener('popstate', event => {
                if (event.state) {
                    if (event.state.depths && event.state.menu) {
                        dispatch((0, action_1.updateMenu)(event.state.depths, event.state.menu, event.state.id, event.state.props, true));
                        if (stateList.length > 1) {
                            stateList.pop(); // 현재 메뉴 제거
                        }
                    }
                    else {
                        const isAdminPage = location.pathname.includes('admin-page');
                        dispatch((0, action_1.updateMenu)(isAdminPage ? constants_1.DEFAULT_ADMIM_DEPTHS : constants_1.DEFAULT_DEPTHS, isAdminPage ? constants_1.DEFAULT_ADMIM_MENU : constants_1.DEFAULT_MENU));
                        stateList = [];
                    }
                }
            });
            break;
        }
        case actionTypes_1.APP_WILL_UNMOUNT: {
            stateList = [];
            break;
        }
        case actionType_1.SET_MENU: {
            const newMenu = {
                depths: action.depths || (0, function_1.getDepths)(store.getState()),
                menu: action.menu,
                id: action.id,
                props: action.props,
                timestamp: Date.now(), // 타임스탬프 추가
            };
            const prevMenu = (0, function_1.getMenuData)(store.getState());
            if (lodash_1.default.isEqual(newMenu.depths, prevMenu.depths) &&
                lodash_1.default.isEqual(newMenu.menu, prevMenu.menu) &&
                lodash_1.default.isEqual(newMenu.props, prevMenu.props)) {
                return next(action);
            }
            if (prevMenu && prevMenu.menu && !activeRef) {
                if (isMenuConditionMatched(prevMenu.menu.menu, prevMenu.menu.detail)) {
                    APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
                        component: DeletePopUpLayout_1.DeletePopUpLayout,
                        componentProps: {
                            isQnA: true,
                            deleteContent: i18next_1.default.t(`supportRoom.answerPopUpcancel`),
                            previosPage: () => {
                                activeRef = true;
                                dispatch((0, action_1.goToPrevMenu)());
                                dispatch((0, action_1.updateMenu)(newMenu.depths, newMenu.menu, newMenu.id, newMenu.props));
                                APP.eventManager.publish(popup_1.TOGGLE_POPUP, null);
                                activeRef = false;
                            },
                        },
                        width: 639,
                        title: i18next_1.default.t(`common.menuMove`),
                        isFit: true,
                    });
                    return;
                }
            }
            // 히스토리 길이 제한
            if (stateList.length >= 50) {
                stateList.shift(); // 가장 오래된 메뉴 제거
            }
            const state = {
                depths: newMenu.depths,
                menu: newMenu.menu,
                id: newMenu.id,
                props: newMenu.props,
            };
            if (!action.isHistory
            // !(newMenu.menu.detail.includes('modify') || newMenu.menu.detail.includes('regist'))
            ) {
                // 히스토리 상태 추가
                window.history.pushState(state, '', action.url || '');
                // 상태를 stateList에 저장
                stateList.push(state);
            }
            const itemName = location.pathname.includes('admin-page') ? 'admin_menu' : 'test_menu';
            localStorage.setItem(itemName, JSON.stringify(stateList)); // 로컬 스토리지 동기화
            return next({ ...action, ...newMenu });
        }
        case actionType_1.GO_TO_PREV_MENU: {
            if (stateList.length <= 1) {
                stateList = [];
                break;
            }
            stateList.pop(); // 현재 페이지 제거
            const currentMenu = (0, function_1.getMenuData)(store.getState());
            // 히스토리에서 가장 최근의 고유한 메뉴 찾기
            let prevMenu = null;
            for (let i = stateList.length - 1; i >= 0; i--) {
                if (!lodash_1.default.isEqual(currentMenu.menu, stateList[i].menu)) {
                    prevMenu = stateList[i];
                    // 현재 인덱스까지의 히스토리만 유지
                    const sliceCount = location.pathname.includes('admin-page') ? i : i + 1;
                    stateList = stateList.slice(0, sliceCount);
                    break;
                }
            }
            if (prevMenu) {
                try {
                    const itemName = location.pathname.includes('admin-page')
                        ? 'admin_menu'
                        : 'test_menu';
                    localStorage.setItem(itemName, JSON.stringify(stateList));
                    if (location.pathname.includes('admin-page')) {
                        if (currentMenu.menu.menu === 'classManagement' &&
                            currentMenu.menu.detail === 'detail') {
                            dispatch((0, action_1.updateMenu)(prevMenu.depths, {
                                ...prevMenu.menu,
                                detail: 'list',
                            }));
                        }
                        else {
                            dispatch((0, action_1.updateMenu)(prevMenu.depths, prevMenu.menu, prevMenu.id, prevMenu.props));
                        }
                    }
                    else {
                        dispatch((0, action_1.updateMenu)(prevMenu.depths, prevMenu.menu, prevMenu.id, prevMenu.props));
                    }
                }
                catch (error) {
                    console.error('Failed to save menu history:', error);
                }
            }
            break;
        }
    }
    return next(action);
});
